import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function GoogleAuthCallback() {
  const { setTokenAndUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');

    if (token) {
      setTokenAndUser(token).then(() => navigate('/dashboard', { replace: true }));
    } else {
      navigate('/login?error=' + (error || 'google_failed'), { replace: true });
    }
    // Intentionally run once on mount to consume the one-time OAuth redirect
    // params; `setTokenAndUser`/`navigate` aren't memoized, so including them
    // would re-fire this on every render without changing the outcome.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
